import DataAccess from "../DataAccessStrategy";
import ClienteFoto from "./ClienteFoto";

function excludeCadastroPendente(client) {
  return client.cadastroPendente !== true;
}

export default class Cliente extends DataAccess {
  constructor() {
    super("Cliente", {
      id: Number,
      shouldSync: Boolean,
      updatedDate: Date,
      hash: String,
      nome: String,
      nomeLatinizado: String,
      nomeConjuge: String,
      nomeConjugeLatinizado: String,
      conjugeCpf: String,
      foto: String,
      dataNascimento: Date,
      sexo: String,
      estadoCivil: String,
      cep: String,
      estado: String,
      cidade: String,
      logradouro: String,
      numero: String,
      pontoReferencia: String,
      observacao: String,
      cpf: String,
      email: String,
      latitude: String,
      longitude: String,
      saldoAtual: String,
      ultimaDataMovimentacao: Date,
      tipoUltimaMovimentacao: String,
      descricaoMovimentacao: String,
      assinatura: String,
      veaco: Boolean,

      updatedAt: Date,
      createdAt: Date,
      hasAppCliente: Boolean,
      cadastroPendente: Boolean,
    });
    this.clientFotoModel = new ClienteFoto();
  }

  getClientsOrderedBy(offset, limit, options) {
    if (!offset && !limit) {
      if (options.order.direction == "DESC") {
        return this.model
          .orderBy(options.order.by)
          .reverse()
          .and(excludeCadastroPendente)
          .toArray();
      }
      return this.model
        .orderBy(options.order.by)
        .and(excludeCadastroPendente)
        .toArray();
    }
    if (options.order.direction == "DESC") {
      return this.model
        .orderBy(options.order.by)
        .reverse()
        .and(excludeCadastroPendente)
        .offset(offset)
        .limit(limit)
        .toArray();
    }
    const clients = this.model
      .orderBy(options.order.by)
      .and(excludeCadastroPendente)
      .offset(offset)
      .limit(limit)
      .toArray();

    return clients;
  }

  async getAll(keyPath, ids) {
    const results = await super.getAll(keyPath, ids);
    if (!keyPath || !ids) {
      return results.filter(excludeCadastroPendente);
    }
    return results;
  }

  countEfetivados() {
    return this.model.filter(excludeCadastroPendente).count();
  }

  getPicture({ id, hash }) {
    if (id) {
      return this.clientFotoModel.getById(id);
    } else if (hash) {
      return this.clientFotoModel.getByHash(hash);
    }
    throw new Error("You must provide an id or hash for the client");
  }

  async getClients(filters, configs) {
    const { offset, limit, orderBy } = configs;
    const listingFilters = [
      {
        functionToApply: "and",
        value: excludeCadastroPendente,
      },
      ...(filters || []),
    ];

    let filteredClients = await this.model.orderBy(orderBy);
    for (const filter of listingFilters) {
      const { functionToApply, value, prop } = filter;
      if (prop) {
        filteredClients = await filteredClients
          .where(prop)
          [functionToApply](value);
      } else {
        filteredClients = await filteredClients[functionToApply](value);
      }
    }

    const resultSet = await filteredClients
      .offset(offset)
      .limit(limit)
      .toArray();

    console.log(`Page: ${offset / limit}: `, resultSet);
    return resultSet;
  }
}
